/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Empty } from '@hb/coffee';

const style = require('./index.module.scss');

@Component({ name: 'CouponNone' })
export default class CouponNone extends Vue {
  @Prop({ default: false })
  private visible!: boolean;

  private render() {
    return (
      <div
        class={style.CouponNone}
        style={!this.visible ? { height: '100%' } : ''}
      >
      <Empty
        type="coupon"
        desc="暂无优惠券~"
        />
      </div>
    );
  }
}
